var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.06372,
    y: 10.1221,
    width: 7.33455,
    height: 1.33333,
    rx: 0.666667,
    transform: "rotate(-45 6.06372 10.1221)",
    fill: "#35B687"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.85352,
    y: 7.06055,
    width: 4.32913,
    height: 1.33333,
    rx: 0.666667,
    transform: "rotate(45 4.85352 7.06055)",
    fill: "#35B687"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.994badde7e6c5cd31ef002fc49826ec3.svg";
export { ForwardRef as ReactComponent };